/******************************************************************************************
 *	Utility Methods
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.utility', []).service(
    'Utility',
    /* @ngInject */
    function(_, Languages, locale, Settings) {
      //Check if str is a valid Adobe ID email address.
      this.isValidEmail = function(str) {
        if (!str || !_.isString(str)) {
          return false;
        }

        return Settings.ADOBEID_EMAIL_REGEXP.test(str) && str.length <= Settings.ADOBEID_MAX_LENGTH;
      };

      this.adobeGoUrl = function(key) {
        var url = 'https://www.adobe.com/go/' + key;

        // Get the current four char locale so we can calculate the correct suffix
        const language = _.toLower(
          Languages.normalizeLanguageCodeToFourChar(locale.getActiveLocaleCode())
        );
        //Suffix is required for any language other than en-us
        if (language !== 'en-us') {
          url = url + '_' + language.substr(3);
        }

        return url;
      };

      //Check if string contains only ASCII printable characters (character code 32-127, HEX 20-7F)
      this.containsOnlyAsciiPrintableChars = function(str) {
        return Settings.ASCII_REGEXP.test(str);
      };

      //Simple HTML escaping
      this.simpleHtmlEscape = function(html) {
        if (!html) {
          return html;
        }

        var str = _(html)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&apos;');

        return str;
      };

      //Detect Internet Explorer version (up to IE11)
      var ieVersion = (function() {
        //Detect IE10 and lower
        var jscriptMap = {
          '5.5': 5.5,
          '5.6': 6,
          '5.7': 7,
          '5.8': 8,
          '9': 9,
          '10': 10
        };
        var jscriptVersion = new Function('/*@cc_on return @_jscript_version; @*/')();
        if (jscriptVersion && jscriptMap[jscriptVersion]) {
          return jscriptMap[jscriptVersion];
        }

        //Detect IE11
        var isIE11 = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
        if (isIE11) {
          return 11;
        }

        //Otherwise
        return -1;
      })();
      this.getIeVersion = function() {
        return ieVersion;
      };

      //Get pseudo-random integer inside interval
      this.getRandomInt = function(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
      };

      //Get pseudo-random number inside interval
      this.getRandomNumber = function(min, max, digits) {
        return +(Math.random() * (max - min) + min).toFixed(digits);
      };

      //Return a pseudo-random alpha-numeric string
      this.getRandomString = (function() {
        var charPool = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var charPoolLength = charPool.length;

        return function(length) {
          var output = '';
          for (var i = 0; i < length; i++) {
            output += charPool[this.getRandomInt(0, charPoolLength - 1)];
          }
          return output;
        };
      })();

      //Looks up `propertySequenceString` on the `data` object and returns its value.
      //e.g. for data={person:{name:'Rooney'}} and propertySequenceString 'person.name',
      //the string 'Rooney' is returned.
      this.getValueFromPropertySequence = function(data, propertySequenceString) {
        if (!data) {
          return data;
        }

        var value = data;
        var propertySequence = _.split(propertySequenceString, '.');
        var count = propertySequence.length;
        for (var i = 0; i < count; i++) {
          if (value) {
            value = value[propertySequence[i]];
          } else {
            return null;
          }
        }

        return value;
      };

      //Check if date is valid
      this.isValidDate = function(date) {
        return date && _.isDate(date) && !window.isNaN(date);
      };

      //Returns an interger representing the number of whole months between 2 dates.
      //To get a rounded-up number of months (i.e. include fractional month), set the roundUpFractionalMonths argument to `true`.
      this.getMonthsBetween = function(date1, date2, roundUpFractionalMonths) {
        //Months will be calculated between start and end dates.
        //Make sure start date is less than end date.
        //But remember if the difference should be negative.
        var startDate = date1;
        var endDate = date2;
        var inverse = false;
        if (date1 > date2) {
          startDate = date2;
          endDate = date1;
          inverse = true;
        }

        //Calculate the differences between the start and end dates
        var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
        var monthsDifference = endDate.getMonth() - startDate.getMonth();
        var daysDifference = endDate.getDate() - startDate.getDate();

        var monthCorrection = 0;
        //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
        //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
        if (roundUpFractionalMonths === true && daysDifference > 0) {
          monthCorrection = 1;
        } else if (roundUpFractionalMonths !== true && daysDifference < 0) {
          //If the day difference between the 2 months is negative, the last month is not a whole month.
          monthCorrection = -1;
        }

        return (inverse ? -1 : 1) * (yearsDifference * 12 + monthsDifference + monthCorrection);
      };

      //Returns an interger representing the number of whole days between 2 dates.
      this.getDaysBetween = function(date1, date2, roundUpFractionalDays) {
        //Days will be calculated between start and end dates.
        //Make sure start date is less than end date.
        //But remember if the difference should be negative.
        var startDate = date1;
        var endDate = date2;
        var inverse = false;
        if (date1 > date2) {
          startDate = date2;
          endDate = date1;
          inverse = true;
        }

        var millisecondsInDay = 86400000; //1000*60*60*24

        //Rounding
        var dayDifference = (endDate - startDate) / millisecondsInDay;
        if (roundUpFractionalDays) {
          dayDifference = Math.ceil(dayDifference);
        } else {
          dayDifference = Math.floor(dayDifference);
        }

        return (inverse ? -1 : 1) * dayDifference;
      };
    }
  );
})();
